import { Component, OnInit, ElementRef, ChangeDetectorRef, ComponentFactoryResolver, ViewRef, ViewChild, ComponentRef, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityServiceForMedicalService } from '../../../services/utility-service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT, AuthService } from 'src/app/shared';
import * as UserDataConfig from '../../../../user-details/config/user-data.config';
import { AlertModal } from 'src/app/model/alert';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { LifeStyleQuestion, HealthLifestyle, Sections, rangeData } from '../../../model/lifestyle.model';
import { Subscription } from 'rxjs';
import * as InitialQuestionActions from '../../../store/actions/initialQuestion.action';
import { UnderWritingData } from '../../../model/lifestyle.post.model';
import { MandatoryQuestionsDirective } from '../../../directives/mandatory-questions-directive';
import { ControlTypesComponent } from '../../control-types/control-types.component';
import { SyncService } from '../../../services/sync.service';
import { AdItem } from '../../ad-item.component';
import { Observable } from 'rxjs/internal/Observable';
import { CurrentMedConToDisplay, BackDataStoreModel } from '../../../model/mcUserJourney.model';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { AnnuitantMedicalConditions } from 'src/app/pages/medical-underwriting/model';
import { MedicalCondQuestionSet } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';


@Component({
  selector: 'app-add-medical-condition',
  templateUrl: './add-medical-condition.component.html',
  styleUrls: ['./add-medical-condition.component.scss']
})
export class AddMedicalConditionComponent implements OnInit, OnDestroy {

  contentData: any;
  public addMCForm: UntypedFormGroup;
  public userInputDetail = UserDataConfig.ElementsConfig;
  displayAlert = false;
  displayPage = true;
  protected alertDiabetesModalConfig: AlertModal;
  private sectionsList: Sections[] = [];
  private questionToDisplayForDCJIQ: LifeStyleQuestion[];
  allowStoresubscribe: boolean;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private lifeStylePayloadFromStore: UnderWritingData;
  @ViewChild(MandatoryQuestionsDirective, { static: true }) mandatoryQuestionsDir: MandatoryQuestionsDirective;
  private componentRefOfControlType: ComponentRef<ControlTypesComponent>;
  initialQuestionStore: Observable<LifeStyleQuestion[]>;
  initialquestionData: any;
  private subscripBeforeLogin: Subscription;
  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private radioBtnQuestionObj: LifeStyleQuestion;
  private errorText: string = '';
  private isnextClicked = false;
  isHOView = false;
  private rangeValidationData: rangeData[];
  private lifeStylePayloadFromStoreObj: UnderWritingData;
  private medCondListFromStore: AnnuitantMedicalConditions[];
  private totalMedCount: number;
  private isEditMode: boolean;
  private currentMedIndex: number;
  private radioBtnDefaultValue: string;
  private newSelectedValue: string;
  public MCExist = false;
  private CMSData;
  public dependantFlag: boolean = false;
  constructor(private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private healthService: HealthService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private syncService: SyncService,
    private utilService: UtilService,
    private store: Store<AppState>,
    private quoteDatacaptureService: QuoteDataCaptureService, private authService: AuthService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.addMedicalcondition;


    this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
    });

    this.initialQuestionStore = store.select(STORE_VAL.initial_question);
    this.initialQuestionStore.subscribe(res => {
      if (res.length > 0) {
        this.initialquestionData = res[0];
        // console.log("Initial Questions from add medical conditions");
        // console.log(this.initialquestionData)
      }
    });

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
          this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
        }
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
        }
      }
    });

    this.syncService.getBackNavData().subscribe(res => {
      this.isEditMode = res.isEdit;
      this.currentMedIndex = res.currentIndex;
      this.radioBtnDefaultValue = res.selectedMedCondn;
    });

    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.userInputDetail.buttonConfig['label'] = 'Next';
    this.userInputDetail.buttonConfig['name'] = 'Next';

    this.syncService.setEditMode(false);

    this.alertDiabetesModalConfig = this.contentData.modalDiabetesMCConfig;
    this.initiateLifestyleFormData();
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });
  }


  ngAfterViewInit() {
    this.getInitialQuestionData();
  }

  initiateLifestyleFormData = () => {
    this.addMCForm = this.fb.group({
      radioBtnForMCList: ['']
    });
  }

  saveFormValues() {
    // //console.log("AMC value bf = >", this.addMCForm.value);

    //  //console.log("AMC value af= >", this.addMCForm.value);
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveAfterLogin() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }

  getInitialQuestionData() {
    this.healthService.getInitialQuestionContent()
      .subscribe(res => {
        //console.log('Response=>', res);
        this.radioBtnQuestionObj = res.section[0].question[0];
        //console.log('radioBtnQuestionObj', this.radioBtnQuestionObj);
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      });

  }

  prepareListForRadioStad(questionObj: LifeStyleQuestion): any[] {
    let returnObj = [];
    // return questionObj.responseValue = questionObj.responseValue ? questionObj.responseValue : [];
    if (questionObj && questionObj.responseValue && questionObj.responseValue.length > 0) {
      questionObj.responseValue.forEach(question => {
        const rangeValidation = this.rangeValidationData.filter(validation => {
          return (validation.valueKey.replace(/ /g, '').toUpperCase() === question.replace(/ /g, '').toUpperCase());
        });
        if (rangeValidation.length > 0) {
          let count = 0;
          const element = rangeValidation[0];
          if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
            count = this.getCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions, element.valueKey);
          } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
            count = this.getCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions, element.valueKey);
          }
          if (count < +element.valueMax) {
            returnObj.push({
              response: element.valueKey,
              enable: true
            });
          } else {
            returnObj.push({
              response: element.valueKey,
              enable: false
            });
            this.MCExist = true;
            // tslint:disable-next-line:max-line-length
            // this.errorText = element.valueKey + ' cannot be added more than ' + element.valueMax + (+element.valueMax === 1 ? ' time.' : ' times.');
          }
        } else {
          returnObj.push({
            response: question,
            enable: true
          });
        }
      });
    }
    return returnObj;
  }

  onChangeOfRadioBtn(selectedValue: string) {
    let urlToFetch: string;
    let count: number = 0;

    this.newSelectedValue = selectedValue;

    this.radioBtnQuestionObj.nextStep.forEach(next => {
      if (next.nextStepSelectedResponse === selectedValue) {
        urlToFetch = next.nextStepValue[0];
      }
    });

    //console.log('rangeValidationData->', this.rangeValidationData);
    this.rangeValidationData.forEach(element => {
      if (element.valueKey === selectedValue) {
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
          count = this.getCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions, selectedValue);
          //console.log('Count->', count);
        } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          count = this.getCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions, selectedValue);
        }
        // if (count < +element.valueMax) {
        //   this.errorText = '';
        // } else {
        //   this.errorText = element.valueKey + ' cannot be added more than ' + element.valueMax + (+element.valueMax === 1 ? ' time.' : ' times.');
        // }
      }
    });
    // this.errorText = count === 0 ? '' : this.errorText;
    this.errorText = null;
    //console.log('urlToFetch', urlToFetch);
    this.initialquestionData = urlToFetch;
    //console.log('initialquestionData Setter', this.initialquestionData);
    const tempCurrentMedConToDisplayObj = new CurrentMedConToDisplay();
    tempCurrentMedConToDisplayObj.tittle = selectedValue;
    tempCurrentMedConToDisplayObj.jsonUrl = urlToFetch;
    tempCurrentMedConToDisplayObj.totalMedCondn = this.totalMedCount;
    //console.log("Total med Count", tempCurrentMedConToDisplayObj);
    // console.log("add0medical-condition:");
    // console.log(JSON.stringify(tempCurrentMedConToDisplayObj))
    this.syncService.setInitialQuestionJson(tempCurrentMedConToDisplayObj);
  }


  getCount(dataToBeSearched, selectedValue: string) {
    let count: number = 0;
    dataToBeSearched.forEach(element => {
      if (element.questionSetName === selectedValue) {
        count++;
      }
    });
    return count;
  }

  getTotalMedCount(medCondList: AnnuitantMedicalConditions[]) {
    this.medCondListFromStore = [];
    medCondList.forEach(element => {
      if ((element.questionSetName === MedicalCondQuestionSet.lifestyle) ||
        element.questionSetName === MedicalCondQuestionSet.adl) {

      }
      else {
        this.medCondListFromStore.push(element);
      }
    });
    if (this.medCondListFromStore.length > 0) {
      this.totalMedCount = this.medCondListFromStore.length;
    }
    else {
      this.totalMedCount = 0;
    }
  }

  clearBackData() {
    const tempBackDataStoreModelObj = new BackDataStoreModel();
    tempBackDataStoreModelObj.currentIndex = null;
    tempBackDataStoreModelObj.isEdit = null;
    tempBackDataStoreModelObj.selectedMedCondn = "";
    //console.log("tempBackDataStoreModelObj Diabetes Screen", tempBackDataStoreModelObj);
    this.syncService.setBackNavData(tempBackDataStoreModelObj);
  }

  addMedicalCondtion() {
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.AMC, MEDICAL_UW_HO_URL.dependant.dependantAMC)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.AMC, MEDICAL_UW_URL.dependant.dependantAMC)]);
    }
  }

  closeModal() {
    this.displayAlert = false;
  }

  closePage() {
    this.displayPage = false;
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }
  }

  navigateToMedicalCondition() {
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }
  }

  //  this.router.navigate(['/home/medical-conditions']);

  gotoNext = () => {
    this.displayAlert = true;
    if (this.isValid()) {
      if (this.isHOView) {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.diabetes, MEDICAL_UW_HO_URL.dependant.dependantDiabetes)]);
        if (this.radioBtnDefaultValue && this.radioBtnDefaultValue !== this.newSelectedValue) {
          this.clearBackData();
        }
      } else {
        if (this.radioBtnDefaultValue && this.radioBtnDefaultValue !== this.newSelectedValue) {
          this.clearBackData();
        }
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.diabetes, MEDICAL_UW_URL.dependant.dependantDiabetes)]);
      }
    } else {
      this.scrollInvalidForm();
    }

  }
  isValid = (): boolean => {
    let flag = true;
    if (!this.errorText) {
      const value = (this.addMCForm.controls && this.addMCForm.controls['radioBtnForMCList']) ?
        this.addMCForm.controls["radioBtnForMCList"].value : null;
      if (!value) {
        this.errorText = 'Please select a medical condition';
        flag = false;
      } else {
        this.errorText = null;
      }
    } else {
      flag = false;
    }
    return flag;
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_AddMedicalCondition;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the healthData object values with CMSData object values */
        this.contentData.header = this.CMSData.string_AddMedicalConditionTitle;
        this.contentData.introduction = this.CMSData.string_AddMedicalConditionSubtitle;
        this.contentData.MCExist = this.CMSData.string_EditMedicalCondition;
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.dependantFlag = true;
          this.contentData.subTitle = this.CMSData.string_ForDependantSubtitle;
        }
        //console.log('changed value = ', this.contentData);

      }
    });
  }
  /** End of code block for CMS */
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }

}
